import { render } from "./addQuestion.vue?vue&type=template&id=14e7edba&scoped=true"
import script from "./addQuestion.vue?vue&type=script&lang=js"
export * from "./addQuestion.vue?vue&type=script&lang=js"

import "./addQuestion.vue?vue&type=style&index=0&id=14e7edba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e7edba"]])

export default __exports__